/** @jsxImportSource @emotion/react */
import React, { createContext } from 'react'
import { AccessType } from './types'
import {
  createFetchContextProps,
  FetchContextType
} from '@signal/core/contextFetch'

export function createAccountPermissionsContext(): React.Context<
  FetchContextType<Array<AccessType>>
> {
  return createContext(createFetchContextProps<Array<AccessType>>())
}

export const AccountPermissionsContext = createAccountPermissionsContext()

export function createTenantPermissionsContext(): React.Context<
  FetchContextType<Array<AccessType>>
> {
  return createContext(createFetchContextProps<Array<AccessType>>())
}

export const TenantPermissionsContext = createTenantPermissionsContext()

export default AccountPermissionsContext
